export default "__VITE_ASSET__Dl47QSOU__"